import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import DotIcon from '@material-ui/icons/Lens';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import ghaPickupStatusStyles from './ghaPickupStatus.module.css';

const styles = (theme: Theme) =>

  createStyles({
    root:{
      width: '85%',
      marginLeft: 'auto'
    },
    ListItem: {
      borderBottom: '1px solid rgba(224, 224, 224, 1)',
      paddingBottom: 5,
      fontSize: '0.8125rem'
    },
    ListItemText: {
      fontSize: '0.8125rem'
    },
    dotIconCommon: {
      fontSize: 14,
      position: 'absolute',
      top: 20,
      right: 35
    },
    green: {
      color: 'green'
    },
    red: {
      color: 'red'
    },
  });

interface GhaAwbPaymentStatusProps {
  classes: any;
  due: boolean;
};

const ghaAwbPaymentStatus = (props: GhaAwbPaymentStatusProps) => {

  const { classes } = props;
  const dotStatusClasses: string = [classes.dotIconCommon, props.due? classes.red : classes.green].join(' ');

  return (

    <div className={ ghaPickupStatusStyles.paymentWrapper } >
      <List className={ classes.root }>
        <DotIcon className={ dotStatusClasses } />
        <ListItem className={ classes.ListItem } >
            <ListItemText classes={{ primary: classes.ListItemText }} primary='Payment'/>
        </ListItem>  
      </List> 
    </div>
  );
};

export default withStyles(styles)(ghaAwbPaymentStatus);